const dataScopeOptions = [
  { name: 'Тільки автор', id: 'AUTHOR_ONLY' },
  { name: 'Свої (участь)', id: 'PARTICIPATING' },
  { name: 'Свої + департамент', id: 'PARTICIPATING_AND_DEPARTMENT' },
  { name: 'Усі в системі', id: 'ALL' },
]

const registrationMarkTypes = [
  { name: 'Штрих-код', id: 'barcode' },
  { name: 'QR-код', id: 'qrcode' },
]

export { dataScopeOptions, registrationMarkTypes }
